import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyCheckboxCss = ":host{display:inline-block;width:20px;height:20px;cursor:pointer;--hover-unchecked-color:rgba(153, 165, 176, 1);--hover-checked-color:rgba(27, 157, 0, 1);--disable-opacity:0.6}:host(:focus-visible){outline:2px solid var(--hover-unchecked-color);outline-offset:2px}:host(:focus-visible:active),:host([checked]:focus-visible){outline:2px solid var(--hover-checked-color)}:host([disabled]){pointer-events:none;opacity:var(--disable-opacity)}:host([disabled][checked]){pointer-events:none}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyCheckbox_originalTabIndex, _MapyCheckbox_cleanup, _MapyCheckbox_handleClick;
const MapyCheckbox$1 = /*@__PURE__*/ proxyCustomElement(class MapyCheckbox extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.change = createEvent(this, "change", 2);
    _MapyCheckbox_originalTabIndex.set(this, undefined);
    _MapyCheckbox_cleanup.set(this, null);
    _MapyCheckbox_handleClick.set(this, (event) => {
      if (!event.defaultPrevented && !this.disabled) {
        this.checked = !this.checked;
        this.change.emit(this.checked);
      }
    });
    this.disabled = false;
    this.checked = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyCheckbox_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    this.hostElement.addEventListener('click', __classPrivateFieldGet(this, _MapyCheckbox_handleClick, "f"), false);
    __classPrivateFieldSet(this, _MapyCheckbox_cleanup, useKeyboardClick(this.hostElement, [' ']), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyCheckbox_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
    this.hostElement.addEventListener('click', __classPrivateFieldGet(this, _MapyCheckbox_handleClick, "f"), false);
  }
  disconnectedCallback() {
    var _a;
    this.hostElement.removeEventListener('click', __classPrivateFieldGet(this, _MapyCheckbox_handleClick, "f"), false);
    (_a = __classPrivateFieldGet(this, _MapyCheckbox_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, !this.checked && h("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { d: "M4.5 17C4.0875 17 3.73437 16.8531 3.44062 16.5594C3.14687 16.2656 3 15.9125 3 15.5V4.5C3 4.0875 3.14687 3.73438 3.44062 3.44063C3.73437 3.14688 4.0875 3 4.5 3H15.5C15.9125 3 16.2656 3.14688 16.5594 3.44063C16.8531 3.73438 17 4.0875 17 4.5V15.5C17 15.9125 16.8531 16.2656 16.5594 16.5594C16.2656 16.8531 15.9125 17 15.5 17H4.5ZM4.5 15.5H15.5V4.5H4.5V15.5Z", fill: "#011E39", "fill-opacity": "0.6" })), this.checked && h("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { d: "M8.9375 10.875L7.6875 9.64583C7.53472 9.49306 7.36111 9.41667 7.16667 9.41667C6.97222 9.41667 6.79861 9.49306 6.64583 9.64583C6.49306 9.79861 6.41667 9.97569 6.41667 10.1771C6.41667 10.3785 6.49306 10.5556 6.64583 10.7083L8.41667 12.4792C8.56944 12.6319 8.74306 12.7083 8.9375 12.7083C9.13194 12.7083 9.30556 12.6319 9.45833 12.4792L13.3542 8.58333C13.5069 8.43056 13.5833 8.25347 13.5833 8.05208C13.5833 7.85069 13.5069 7.67361 13.3542 7.52083C13.2014 7.36806 13.0278 7.29167 12.8333 7.29167C12.6389 7.29167 12.4653 7.36806 12.3125 7.52083L8.9375 10.875ZM4.5 17C4.08333 17 3.72917 16.8542 3.4375 16.5625C3.14583 16.2708 3 15.9167 3 15.5V4.5C3 4.08333 3.14583 3.72917 3.4375 3.4375C3.72917 3.14583 4.08333 3 4.5 3H15.5C15.9167 3 16.2708 3.14583 16.5625 3.4375C16.8542 3.72917 17 4.08333 17 4.5V15.5C17 15.9167 16.8542 16.2708 16.5625 16.5625C16.2708 16.8542 15.9167 17 15.5 17H4.5Z", fill: "#1EAE00" })));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyCheckboxCss; }
}, [1, "mapy-checkbox", {
    "disabled": [516],
    "checked": [516]
  }]);
_MapyCheckbox_originalTabIndex = new WeakMap(), _MapyCheckbox_cleanup = new WeakMap(), _MapyCheckbox_handleClick = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-checkbox"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-checkbox":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyCheckbox$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyCheckbox = MapyCheckbox$1;
const defineCustomElement = defineCustomElement$1;

export { MapyCheckbox, defineCustomElement };

//# sourceMappingURL=mapy-checkbox.js.map